import { render, staticRenderFns } from "./DriverManage.vue?vue&type=template&id=510ca982&scoped=true"
import script from "./DriverManage.vue?vue&type=script&lang=js"
export * from "./DriverManage.vue?vue&type=script&lang=js"
import style0 from "./DriverManage.vue?vue&type=style&index=0&id=510ca982&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510ca982",
  null
  
)

export default component.exports